import React from 'react';
import CarriersView from './common/CarriersView.component';
import GeneralView from './common/GeneralView.component';
import LabelCustomizationView from './common/LabelCustomizationView.component';
import ServiceOptionsView from './common/ServiceOptionsView.component';
import MailGeneralView from './mail/GeneralView.component';
import PrintOnOptionsView from './mail/PrintOnOptions.component';
import RefundAssistView from './mail/RefundAssistView.component';
import InternationalView from './orders/InternationalView.component';
import LabelMessagesView from './orders/LabelMessagesView.component';
import PackingSlipsView from './orders/PackingSlipsView.component';
import SettingsIdentifiers from './SettingsIdentifiers.enum';

const SettingsContent = ({ activeTab, completionCallback }) => {
	// TODO: Add new components here as they're made
	const renderComponent = () => {
		switch (activeTab) {
			case SettingsIdentifiers.Common.General:
				return <GeneralView completionCallback={completionCallback} />;
			case SettingsIdentifiers.Common.Carriers:
				return <CarriersView />;
			case SettingsIdentifiers.Common.ServiceOptions:
				return <ServiceOptionsView completionCallback={completionCallback} />;
			case SettingsIdentifiers.Common.LabelCustomization:
				return (
					<LabelCustomizationView completionCallback={completionCallback} />
				);
			case SettingsIdentifiers.Mail.General:
				return <MailGeneralView completionCallback={completionCallback} />;
			case SettingsIdentifiers.Mail.PrintOnOptions:
				return <PrintOnOptionsView completionCallback={completionCallback} />;
			case SettingsIdentifiers.Mail.RefundAssist:
				return <RefundAssistView completionCallback={completionCallback} />;
			case SettingsIdentifiers.Orders.International:
				return <InternationalView completionCallback={completionCallback} />;
			case SettingsIdentifiers.Orders.LabelMessages:
				return <LabelMessagesView completionCallback={completionCallback} />;
			case SettingsIdentifiers.Orders.PackingSlips:
				return <PackingSlipsView completionCallback={completionCallback} />;
			default:
				return null;
		}
	};

	return <div className="settings-content">{renderComponent()}</div>;
};

export default SettingsContent;
